// Zotte Zomer Ronse 2026 — Artists seed data
// Featured artists (with photos cropped from the official affiche):
//   Astrid Stockman (25/7), Belle Perez (25/7), Stan Van Samang (29/8)
// All other artists use a fallback card with initials on a pastel accent.
// Slugs are url-friendly anchors.

export const ARTISTS = [
    // ===== FEATURED 25/7 =====
    {
        id: 'astrid-stockman',
        name: 'Astrid Stockman',
        slug: 'astrid-stockman',
        day: '25/7',
        dayId: 'stadstuin-25-07',
        location: 'Stadstuin',
        photo: '/assets/artists/astrid-stockman.jpg',
        ringClass: 'zz-ring-pink',
        accent: 'pink',
        ringObjectPosition: 'center 55%',
        featured: true,
        sortOrder: 1,
    },
    {
        id: 'belle-perez',
        name: 'Belle Perez',
        slug: 'belle-perez',
        day: '25/7',
        dayId: 'stadstuin-25-07',
        location: 'Stadstuin',
        photo: '/assets/artists/belle-perez.jpg',
        ringClass: 'zz-ring-yellow',
        accent: 'yellow',
        ringObjectPosition: '70% 45%',
        featured: true,
        sortOrder: 2,
    },
    // ===== FEATURED 29/8 =====
    {
        id: 'stan-van-samang',
        name: 'Stan Van Samang',
        slug: 'stan-van-samang',
        day: '29/8',
        dayId: 'grote-markt-29-08',
        location: 'Grote Markt',
        photo: '/assets/artists/stan-van-samang.jpg',
        ringClass: 'zz-ring-mint',
        accent: 'mint',
        ringObjectPosition: '60% 45%',
        featured: true,
        sortOrder: 3,
    },

    // ===== 11/7 — Kleine Markt (no photos, fallback cards) =====
    { id: 'neon-forest', name: 'Neon Forest', slug: 'neon-forest', day: '11/7', dayId: 'kleine-markt-11-07', location: 'Kleine Markt', accent: 'pink', ringClass: 'zz-ring-pink', sortOrder: 10 },
    { id: 'fixkes', name: 'Fixkes', slug: 'fixkes', day: '11/7', dayId: 'kleine-markt-11-07', location: 'Kleine Markt', accent: 'pink', ringClass: 'zz-ring-pink', sortOrder: 11 },
    { id: 'question', name: 'Question', slug: 'question', day: '11/7', dayId: 'kleine-markt-11-07', location: 'Kleine Markt', accent: 'pink', ringClass: 'zz-ring-pink', sortOrder: 12 },
    { id: 'drezz', name: 'Drezz', slug: 'drezz', day: '11/7', dayId: 'kleine-markt-11-07', location: 'Kleine Markt', accent: 'pink', ringClass: 'zz-ring-pink', sortOrder: 13 },

    // ===== 25/7 — Stadstuin (rest, no photos) =====
    { id: 'euforia', name: 'Euforia', slug: 'euforia', day: '25/7', dayId: 'stadstuin-25-07', location: 'Stadstuin', accent: 'mint', ringClass: 'zz-ring-mint', sortOrder: 20 },
    { id: 'remastered-2-djs', name: "Remastered2DJ's", slug: 'remastered2djs', day: '25/7', dayId: 'stadstuin-25-07', location: 'Stadstuin', accent: 'mint', ringClass: 'zz-ring-mint', sortOrder: 21 },

    // ===== 29/8 — Grote Markt (rest, no photos) =====
    { id: 'sanchez-taelmanoz', name: 'Sanchez Taelmanoz', slug: 'sanchez-taelmanoz', day: '29/8', dayId: 'grote-markt-29-08', location: 'Grote Markt', accent: 'yellow', ringClass: 'zz-ring-yellow', sortOrder: 30 },
    { id: 'elle-fray', name: 'Elle Fray', slug: 'elle-fray', day: '29/8', dayId: 'grote-markt-29-08', location: 'Grote Markt', accent: 'yellow', ringClass: 'zz-ring-yellow', sortOrder: 31 },
    { id: 'lajos-and-the-gang', name: 'Lajos & The Gang', slug: 'lajos-and-the-gang', day: '29/8', dayId: 'grote-markt-29-08', location: 'Grote Markt', accent: 'yellow', ringClass: 'zz-ring-yellow', sortOrder: 32 },
    { id: 'monsieur', name: 'Monsieur', slug: 'monsieur', day: '29/8', dayId: 'grote-markt-29-08', location: 'Grote Markt', accent: 'yellow', ringClass: 'zz-ring-yellow', sortOrder: 33 },
];

export const DAYS = [
    { id: 'all', label: 'Alle dagen' },
    { id: 'kleine-markt-11-07', label: '11/7', short: '11/7', location: 'Kleine Markt' },
    { id: 'stadstuin-25-07', label: '25/7', short: '25/7', location: 'Stadstuin' },
    { id: 'grote-markt-29-08', label: '29/8', short: '29/8', location: 'Grote Markt' },
];
